import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, combineLatest, of } from 'rxjs';
import { map, flatMap, switchAll } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../core/settings';
import { MicrobiologyData, MicrobiologyDataReadModel } from './microbiology-data';
import { Site } from '../../sites/site';
import { Subject } from '../../subjects/subject';

@Injectable()
export class MicrobiologyStorage {

    constructor(
        private settings: Settings,
        private http: HttpClient
    ) {
    }

    public get dataDict(): { [microBiologyCategory: string]: (selectedSiteId: Observable<number>) => Observable<MicrobiologyData[]> } {
        return {
            'isolate-culture-data': (selectedSiteId: Observable<number>) => this.getMicrobiologyForSite(selectedSiteId),
        };
    }

    public get dataDictPivot(): { [microBiologyCategory: string]: (selectedSite: Observable<Site>, selectedSubject: Observable<Subject>) => Observable<MicrobiologyData[]> } {
        return {
            'microbiology-pivot': (selectedSite: Observable<Site>, selectedSubject: Observable<Subject>) => this.getMicrobiologyIsolateCultureForSubject(selectedSite, selectedSubject)
        };
    }

    public getMicrobiologyForSite(selectedSiteId: Observable<number>): Observable<MicrobiologyData[]> {
        return selectedSiteId
            .pipe(
                map((siteId: number) =>
                    this.http.get(`${this.settings.apiUrl}/sites/${siteId}/microbiology`)
                        .pipe(map((response) =>
                            deserialize(response, MicrobiologyDataReadModel).results))),
                flatMap((x) => of(of(null), x)),
                switchAll());
    }

    public getMicrobiologyIsolateCultureForSubject(selectedSite: Observable<Site>, selectedCtSubject: Observable<Subject>): Observable<MicrobiologyData[]> {
        return combineLatest(
            selectedSite,
            selectedCtSubject
        ).pipe(
            map(([site, ctSubject]: [Site, Subject]) =>
                this.http.get(
                    `${this.settings.apiUrl}/sites/${site.siteId}/subjects/${ctSubject.ctSubjectId}/microbiology`)
                    .pipe(map((response) =>
                        deserialize(response, MicrobiologyDataReadModel).results))),
            flatMap((x) => of(of(null), x)),
            switchAll());
    }
}